<template>
  <v-dialog max-width="600" v-model="show">
    <v-card>
      <v-card-title class="headline">{{
        $t('components.documentRename.headline')
      }}</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <!-- :readonly="!editable" -->
              <v-text-field
                :label="$t('fields.name')"
                outline
                v-model="document.original_name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="rename" color="success" v-if="editable">{{ $t('buttons.save') }}</v-btn> -->
        <v-btn @click="rename" color="success">{{ $t('buttons.save') }}</v-btn>
        <v-btn @click.stop="show = false" color="error">{{
          $t('buttons.close')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Document from '@/models/Document.js'

export default {
  props: {
    // editable: Boolean,
    value: Boolean,
    documentProp: Document,
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    value: function () {
      this.document = new Document(this.documentProp)
    },
  },

  data() {
    return {
      document: new Document(this.documentProp),
    }
  },

  methods: {
    rename() {
      this.$emit('document-rename', this.document)

      // Close modal.
      this.show = false
    },
  },
}
</script>
